module.exports = __webpack_public_path__ + "img/tedingduixiang.7177b88a.png";